import React, { Component } from 'react';
 
const AnyReactComponent = ({ text }: { text: string }) => <div>{text}</div>;
 
class Adresse extends Component {
  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33
    },
    zoom: 11
  };
 
  render() {
    return (
    <div className="card shadow-sm" style={{ maxWidth: '420px' }}>
      <div className="card-body">
        <h5 className="card-title mb-3">
          <i className="bi bi-geo-alt-fill me-2"></i>Nous contacter
        </h5>

        <p className="mb-1"><strong>Entreprise :</strong> Studio Créatif XYZ</p>
        <p className="mb-1"><strong>Adresse :</strong> 123 Rue Principale, Québec, QC G1A 2B3</p>
        <p className="mb-1">
          <strong>Téléphone :</strong>
          <a href="tel:+14185551234" className="text-decoration-none">+1 418 555‑1234</a>
        </p>
        <p className="mb-1">
          <strong>Email :</strong>
          <a href="mailto:contact@studioxyz.com" className="text-decoration-none">contact@studioxyz.com</a>
        </p>
        <p className="mb-3"><strong>Horaires :</strong> Lundi – Vendredi, 9h à 17h</p>

        <a
          href="https://www.google.com/maps?q=123+Rue+Principale,+Québec,+QC"
          target="_blank"
          rel="noopener noreferrer"
          className ="btn btn-primary w-100"
        >
          Voir sur Google Maps
        </a>
      </div>
    </div>
    );
  }
}
 
export default Adresse;